'use client';

import { useEffect } from 'react';
import { TypecoordinationStatus } from './types/Typeschild_id';
import UploadingCom from './UploadingCom';
import { cn } from '@/lib/utils';
import { FaTrashAlt } from 'react-icons/fa';
import { IoMdAdd } from 'react-icons/io';
import { Button } from '@/components/ui/button';

export default function SectionSendFile(props: TypecoordinationStatus) {
    const { coordinationStatus, setdisabledBtn, files, setFiles } = props;

    const getNewId = () => {
        const numericKeys = Object.keys(files)
            .map((k) => parseInt(k, 10))
            .filter((n) => !isNaN(n));  

        const maxId = numericKeys.length > 0 ? Math.max(...numericKeys) : 0;
        return (maxId + 1).toString();
    };
    const handleClick = () => {
        const newId = getNewId();

        setFiles((f) => {
            return { ...f, [newId]: { file: null, deletable: true } };
        });
    };

    const handleDelete = (name: string) => {
        setFiles((f) => {
            const newFiles = { ...f };
            delete newFiles[name];
            return newFiles;
        });
    };

    function handleSetFile(name: string, file: File | null) {
        setFiles((f) => {
            const newFiles = { ...f };
            newFiles[name] = { file, deletable: f[name].deletable };
            return newFiles;
        });
    }

    useEffect(() => {
        let count = 0;
        if (
            coordinationStatus.coordination === 'دارد' &&
            coordinationStatus.coordination_fields &&
            coordinationStatus.coordination_fields.length > 0
        ) {
            coordinationStatus.coordination_fields.forEach((name) => {
                if (
                    Object.keys(files).includes(name) &&
                    files[name].file != null
                )
                    count++;
            });
            setdisabledBtn(
                coordinationStatus.coordination === 'دارد' &&
                    count !== coordinationStatus.coordination_fields.length,
            );
        } else {
            setdisabledBtn(false);
        }
    }, [files]); 

    if (
        coordinationStatus.coordination === 'دارد' &&
        coordinationStatus.coordination_fields &&
        coordinationStatus.coordination_fields.length > 0
    ) {
        return (
            <div className="smp:!px-6 px-4 py-7 flex flex-col gap-2 bg-white !rounded-2xl">
                <h3 className="text-sm md:!text-base text-blue">
                    بارگذاری فایل:
                </h3>
                {coordinationStatus.coordination === 'دارد' &&
                    coordinationStatus.coordination_fields &&
                    coordinationStatus.coordination_fields.length > 0 && (
                        <p className="text-black font-semibold text-xs py-1.5">
                            بنا به درخواست پزشک، نیاز به مدارک پزشکی از قبیل
                            (نسخه - معرفی نامه و ...) یا (مدارک اعلامی در پیش
                            نیاز ویزیت) برای ثبت نوبت میباشد. لطفا مدارک خواسته
                            شده را در بخش زیر بارگذاری نمایید.
                        </p>
                    )}
                <div
                    className={cn(
                        'gap-3 sm:p-2 rounded-md flex flex-col',
                        Object.keys(files).length > 0 &&
                            'sm:!border border-gray-300',
                        Object.keys(files).length > 0 ? 'py-4' : undefined,
                    )}
                >
                    <div className="gap-1">
                        {Object.keys(files)
                            .sort((a, b) => {
                                if (!files[a].deletable && files[b].deletable)
                                    return -1;
                                if (files[a].deletable && !files[b].deletable)
                                    return 1;
                                return 0;
                            })
                            .map((i) => (
                                <div
                                    key={i}
                                    className="flex flex-row justify-start items-center gap-1"
                                >
                                    <div className="flex justify-center items-center ">
                                        <UploadingCom
                                            handleSetFile={handleSetFile}
                                            label={i}
                                            currentFile={files[i]}
                                        />
                                        {files[i].deletable && (
                                            <button
                                                type="button"
                                                className='mb-9'
                                                onClick={() => handleDelete(i)}
                                            >
                                                <p className="hover:text-red-500">
                                                    <FaTrashAlt className="inline text-xl transition-colors mr-1 hover:text-red-500" />
                                                </p>
                                            </button>
                                        )}
                                    </div>
                                </div>
                            ))}
                    </div>
                </div>
                <div className="flex flex-col gap-2">
                    <p className="text-red-600 text-sm py-1">
                        درصورت داشتن مدارک و اسناد درمانی موردنیاز جهت ویزیت
                        میتوانید فایل مربوطه را از اینجا ارسال نمایید !
                    </p>
                    <div className="flex justify-start">
                        <Button
                            className="self-start !bg-blue smp:!w-max w-full !h-10 !py-2 !text-white !rounded-2xl"
                            onClick={handleClick}
                        >
                            <IoMdAdd className="text-2xl" />
                            بارگذاری فایل بیشتر
                        </Button>
                    </div>
                </div>
            </div>
        );
    }
}
